import { render, staticRenderFns } from "./List.vue?vue&type=template&id=2410f068&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&id=2410f068&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2410f068",
  null
  
)

export default component.exports